export default {
  aoyama: {
    // 父へのメッセージ（幼少時代 編）
    a: "何かイベントがあるたびに、名カメラマンに変身してくれた＜ID-3＞。<br />あの頃のアルバムを開くと、＜ID-3＞の優しいまなざしがあふれていて胸がいっぱいになります。",
    b: "はじめての挑戦はいつも失敗ばかりだったけど、できるようになるまで＜ID-3＞は見守ってくれました。<br />「努力はきっと実る」そう思えるようになったのは、＜ID-3＞と過ごしたあの日々のおかげです。",
    c: "小さい頃、どんなに不安なことでも不思議といつも乗り越えることができました。<br />＜ID-3＞がそばにいてくれること、それは私にとって無敵のお守りでした。",
    d: "＜ID-3＞は、太陽みたいにいつも笑っていてくれました。<br />＜ID-3＞の笑顔がみんなを照らしてくれたから、わが家はいつも明るくて、幸せな場所でした。",
    e: "どちらかというと、＜ID-3＞はしつけに厳しい人でした。<br />でも今は、それが＜ID-3＞なりの優しさだったことが痛いほどによくわかります。",
    f: "休日というのは、大人になった私にとってとにかくのんびりしたい時間です。<br />＜ID-3＞もきっとそうだったはずなのに、お休みの日にたくさん遊んでくれてありがとう。",
    g: "単身赴任をしてくれていたとき、家族とはなれて暮らすのは、きっと＜ID-3＞もつらかったと思います。<br />あの頃はよく分かっていなかったけれど、遠くから家族を支えてくれて本当にありがとう。",

    // 父へのメッセージ（学生時代 編）
    h: "毎日早起きして、当たりまえのようにお弁当を持たせてくれた＜ID-3＞。<br />どれだけ大変だったか想像もできません。愛情たっぷりのお弁当を心からありがとう。",
    i: "思い返してみると、私はとても充実した学生生活を送れたと思います。<br />それは私以上に大変な思いをしながら、伴走しつづけてくれた＜ID-3＞のおかげです。",
    j: "＜ID-3＞は昔から、私が本気でやりたいことは思いっきりやらせてくれる人でした。<br />これまで経験させてもらったことすべてが、私にとってかけがえのない宝物です。",
    k: "＜ID-3＞には、数えきれないくらい送り迎えをしてもらいました。<br />遅くなって叱られることもあったけど、必ず迎えにきてくれる優しさが嬉しかったです。",
    l: "＜ID-3＞はいつだって子どもが一番で、自分のことは二の次の人でした。<br />＜ID-3＞が無償の愛を注いでくれたから、私はちゃんと人を愛せる大人になれたと思います。",
    m: "人生の岐路に立ち、どちらに進むべきか悩んだこともありました。<br />でも、どんな道を選んだとしても背中を押してくれる＜ID-3＞がいたから、私は前を向くことができました。",
    n: "あのとき、自分のことみたいに一緒に喜んでくれてありがとう。<br />＜ID-3＞のうれし涙を見て、これまで頑張ってきてよかったと心から思いました。",
    o: "私が悲しくてどうしようもなかったとき、＜ID-3＞はそっとそばにいてくれました。<br />悲しみを分け合ってくれる＜ID-3＞の存在が、私の心をいつも守ってくれました。",
    p: "＜ID-3＞は、家族の前で弱いところを見せない人でした。<br />「＜ID-3＞がいれば大丈夫」<br />その背中には、そんな頼もしい安心感がありました。",

    // 父へのメッセージ（社会人 編）
    q: "実家を出てから気付いたこと。それは＜ID-3＞の偉大さです。<br />大きなことから小さなことまで、どれだけ頼ってきたのかを身にしみて感じました。",
    r: "私にとって＜ID-3＞は、親であり、なんでも話せる親友のような存在です。<br />いつもそっと手を差し伸べてくれる＜ID-3＞に、どれだけ救われてきたかわかりません。",
    s: "実家に帰ることも、だんだん少なくなってしまっています。<br />だから帰ったときの＜ID-3＞らしいおもてなしが、いつもすごく懐かしくて嬉しいんです。",
    // ＜ID-4＞で「ある」を選択した場合のみ表示
    t: "覚えていないかもしれないけど、昔＜ID-3＞からもらった大切な言葉があります。<br />「＜ID-4＞」きっと＜ID-3＞が思っているよりずっと、この言葉は私の人生を変えてくれました。",
    u: "心配をかけたくない親心からか、＜ID-3＞は体のことをあまり話してくれません。<br />でも、親のことが誰よりも心配なのが子ども心です。<br />たまには心配くらいさせてください。",
    v: "親子だから、どうしたって＜ID-3＞と私は似ています。<br />そこは似なくていいかなと思うこともあるけれど、＜ID-3＞からもらったギフトを、たくさんの人が素敵だと言ってくれます。",
    w: "歳を重ねて、＜ID-3＞との会話は少しずつ変わってきたように思います。<br />これまで聞けなかった本音を話してくれると、大人として認められた気がして、なんだか嬉しくなるんです。",
    // ＜ID-9＞＜ID-10＞で選択された兄弟姉妹条件に応じて、表示するイラストを切り替え（P.40参照）
    // ＜ID-9＞で、兄弟姉妹が1人以上いると選択した場合のみ表示
    x: "＜ID-3＞は子どもたちを比べず、それぞれの個性を大切にしてくれました。<br />そのおかげで私たちは、自分たちらしくのびのびと成長できたのだと思います。",
    y: "子どもに親の期待を押しつけるようなことを、＜ID-3＞は絶対にしませんでした。<br />自分のことは自分で決めるもの。<br />そうやって育ててくれたから、私はいつだって自由でした。",
    z: "これまでの人生を振り返ると、人との出会いにとても恵まれていたと思います。<br />住んだ場所や通った学校、＜ID-3＞がその出会いを作ってくれたんだよね。本当にありがとう。",
    // ＜ID-11＞で、子どもが1人以上いると選択した場合のみ表示
    aa: "子どもを育てるようになって、はじめて子育ての大変さを知りました。<br />まったく自信はないけれど、＜ID-3＞みたいな親を目指して、私なりに頑張りたいなと思っています。",
    // ＜ID-11＞で選択された子ども数に応じて、表示するイラストを切り替え（P.41参照）
    // ＜ID-11＞で、子どもが1人以上いると選択した場合のみ表示
    ab: "＜ID-12＞のことを、いつもかわいがってくれてありがとう。<br />＜ID-12＞と遊ぶ＜ID-3＞を見ていると、私もこんな風にかわいがってもらっていたんだなぁ、と幸せな気持ちに包まれます。",
    ac: "いくつになっても人生を謳歌している＜ID-3＞。<br />＜ID-3＞の元気な姿から、いつも元気をもらっています。",
    ad: "＜ID-3＞に大切に育ててもらったから、私にも大切な人ができました。<br />いつも私の大切な人のことまで、気にかけてくれてありがとう。",

    // 母へのメッセージ（幼少時代 編）
    ae: "何かイベントがあるたびに、名カメラマンに変身してくれた＜ID-5＞。<br />あの頃のアルバムを開くと、＜ID-5＞の優しいまなざしがあふれていて胸がいっぱいになります。",
    af: "はじめての挑戦はいつも失敗ばかりだったけど、できるようになるまで＜ID-5＞は見守ってくれました。<br />「努力はきっと実る」そう思えるようになったのは、＜ID-5＞と過ごしたあの日々のおかげです。",
    ag: "小さい頃、どんなに不安なことでも不思議といつも乗り越えることができました。<br />＜ID-5＞がそばにいてくれること、それは私にとって無敵のお守りでした。",
    ah: "＜ID-5＞は、太陽みたいにいつも笑っていてくれました。<br />＜ID-5＞の笑顔がみんなを照らしてくれたから、わが家はいつも明るくて、幸せな場所でした。",
    ai: "どちらかというと、＜ID-5＞はしつけに厳しい人でした。<br />でも今は、それが＜ID-5＞なりの優しさだったことが痛いほどによくわかります。",
    aj: "休日というのは、大人になった私にとってとにかくのんびりしたい時間です。<br />＜ID-5＞もきっとそうだったはずなのに、お休みの日にたくさん遊んでくれてありがとう。",
    ak: "単身赴任をしてくれていたとき、家族とはなれて暮らすのは、きっと＜ID-5＞もつらかったと思います。<br />あの頃はよく分かっていなかったけれど、遠くから家族を支えてくれて本当にありがとう。",

    // 母へのメッセージ（学生時代 編）
    al: "毎日早起きして、当たりまえのようにお弁当を持たせてくれた＜ID-5＞。<br />どれだけ大変だったか想像もできません。愛情たっぷりのお弁当を心からありがとう。",
    am: "思い返してみると、私はとても充実した学生生活を送れたと思います。<br />それは私以上に大変な思いをしながら、伴走しつづけてくれた＜ID-5＞のおかげです。",
    an: "＜ID-5＞は昔から、私が本気でやりたいことは思いっきりやらせてくれる人でした。<br />これまで経験させてもらったことすべてが、私にとってかけがえのない宝物です。",
    ao: "＜ID-5＞には、数えきれないくらい送り迎えをしてもらいました。<br />遅くなって叱られることもあったけど、必ず迎えにきてくれる優しさが嬉しかったです。",
    ap: "＜ID-5＞はいつだって子どもが一番で、自分のことは二の次の人でした。<br />＜ID-5＞が無償の愛を注いでくれたから、私はちゃんと人を愛せる大人になれたと思います。",
    aq: "人生の岐路に立ち、どちらに進むべきか悩んだこともありました。<br />でも、どんな道を選んだとしても背中を押してくれる＜ID-5＞がいたから、私は前を向くことができました。",
    ar: "あのとき、自分のことみたいに一緒に喜んでくれてありがとう。<br />＜ID-5＞のうれし涙を見て、これまで頑張ってきてよかったと心から思いました。",
    as: "私が悲しくてどうしようもなかったとき、＜ID-5＞はそっとそばにいてくれました。<br />悲しみを分け合ってくれる＜ID-5＞の存在が、私の心をいつも守ってくれました。",
    at: "＜ID-5＞は、家族の前で弱いところを見せない人でした。<br />「＜ID-5＞がいれば大丈夫」<br />その背中には、そんな頼もしい安心感がありました。",

    // 母へのメッセージ（社会人 編）
    au: "実家を出てから気付いたこと。それは＜ID-5＞の偉大さです。<br />大きなことから小さなことまで、どれだけ頼ってきたのかを身にしみて感じました。",
    av: "私にとって＜ID-5＞は、親であり、なんでも話せる親友のような存在です。<br />いつもそっと手を差し伸べてくれる＜ID-5＞に、どれだけ救われてきたかわかりません。",
    aw: "実家に帰ることも、だんだん少なくなってしまっています。<br />だから帰ったときの＜ID-5＞らしいおもてなしが、いつもすごく懐かしくて嬉しいんです。",
    // ＜ID-4＞で「ある」を選択した場合のみ表示
    ax: "覚えていないかもしれないけど、昔＜ID-5＞からもらった大切な言葉があります。<br />「＜ID-6＞」<br />きっと＜ID-5＞が思っているよりずっと、この言葉は私の人生を変えてくれました。",
    ay: "心配をかけたくない親心からか、＜ID-5＞は体のことをあまり話してくれません。<br />でも、親のことが誰よりも心配なのが子ども心です。<br />たまには心配くらいさせてください。",
    az: "親子だから、どうしたって＜ID-5＞と私は似ています。<br />そこは似なくていいかなと思うこともあるけれど、＜ID-5＞からもらったギフトを、たくさんの人が素敵だと言ってくれます。",
    ba: "歳を重ねて、＜ID-5＞との会話は少しずつ変わってきたように思います。<br />これまで聞けなかった本音を話してくれると、大人として認められた気がして、なんだか嬉しくなるんです。",
    // ＜ID-9＞＜ID-10＞で選択された兄弟姉妹条件に応じて、表示するイラストを切り替え
    // ＜ID-9＞で、兄弟姉妹が1人以上いると選択した場合のみ表示
    bb: "＜ID-5＞は子どもたちを比べず、それぞれの個性を大切にしてくれました。<br />そのおかげで私たちは、自分たちらしくのびのびと成長できたのだと思います。",
    bc: "子どもに親の期待を押しつけるようなことを、＜ID-5＞は絶対にしませんでした。<br />自分のことは自分で決めるもの。<br />そうやって育ててくれたから、私はいつだって自由でした。",
    bd: "これまでの人生を振り返ると、人との出会いにとても恵まれていたと思います。<br />住んだ場所や通った学校、＜ID-5＞がその出会いを作ってくれたんだよね。本当にありがとう。",
    // ＜ID-11＞で、子どもが1人以上いると選択した場合のみ表示
    be: "子どもを育てるようになって、はじめて子育ての大変さを知りました。<br />まったく自信はないけれど、＜ID-5＞みたいな親を目指して、私なりに頑張りたいなと思っています。",
    // ＜ID-11＞で選択された子ども数に応じて、表示するイラストを切り替え（P.41参照）
    // ＜ID-11＞で、子どもが1人以上いると選択した場合のみ表示
    bf: "＜ID-12＞のことを、いつもかわいがってくれてありがとう。<br />＜ID-12＞と遊ぶ＜ID-5＞を見ていると、私もこんな風にかわいがってもらっていたんだなぁ、と幸せな気持ちに包まれます。",
    bg: "いくつになっても人生を謳歌している＜ID-5＞。<br />＜ID-5＞の元気な姿から、いつも元気をもらっています。",
    bh: "＜ID-5＞に大切に育ててもらったから、私にも大切な人ができました。<br />いつも私の大切な人のことまで、気にかけてくれてありがとう。",
  },
  okuta: {
    // 父へのメッセージ（幼少時代 編）
    a: "昔は自分の名前が好きになれなくて、他の名前に憧れたこともありました。<br />でもこの名に込められた＜ID-3＞の想いを知ってから、自分の名前がとても誇らしくなりました。",
    b: "子どもの頃、イベントのたびに名カメラマンに変身してくれた＜ID-3＞。<br />今でもときどき昔のアルバムを開きたくなるのは、そこに＜ID-3＞の温かい眼差しが残っているからです。",
    c: "はじめての挑戦は失敗してばかり。＜ID-3＞はいつも、できるようになるまで辛抱強く見守ってくれました。<br />「努力はきっと実る」そう思えるようになったのは、間違いなく＜ID-3＞と過ごしたあの日々のおかげです。",
    d: "小さい頃、どんなに不安なことでも不思議と最後には乗り越えることができました。<br />＜ID-3＞がそばにいてくれること。それはボクにとって無敵のお守りでした。",
    e: "＜ID-3＞は、太陽みたいにいつも笑っていてくれました。<br />その笑顔に照らされて、わが家はいつもにぎやかで温かい場所でした。",
    f: "どちらかというと、＜ID-3＞はしつけに厳しい人でした。<br />でも今はそれが＜ID-3＞なりの優しさだったことが、痛いほどによくわかります。",
    g: "休日というのは、大人になったボクにとってとにかくのんびりしたい時間です。<br />きっと＜ID-3＞もそうだったはずなのに、休みの日にたくさん思い出を作ってくれてありがとう。",
    h: "人一倍家族愛の強い＜ID-3＞のことだから、単身赴任で家族と離れるのはきっとつらかったと思います。<br />家族のためなら自分の犠牲もいとわない。そんな＜ID-3＞は、誰が何と言おうとカッコいいです。",

    // 父へのメッセージ（学生時代 編）
    i: "誰よりも早く起きて、当たり前のように毎日弁当を持たせてくれた＜ID-3＞。<br />どれだけ大変だったか想像もできません。献身的にサポートしてくれて本当にありがとう。",
    j: "思い返してみると、ボクはとても充実した学生生活を送れたと思います。<br />それはボク以上に大変な思いをしながら、伴走しつづけてくれた＜ID-3＞のおかげです。",
    k: "＜ID-3＞は昔から、ボクが本気でやりたいことには支援を惜しまない人でした。<br />これまで経験させてもらったことすべてが、ボクにとってかけがえのない宝物です。",
    l: "いつだったか、＜ID-3＞がボクを守るために本気で怒ってくれたことがありました。<br />いつもは穏やかな人だから、守ってくれて本当にうれしかったのを今でも覚えています。",
    m: "＜ID-3＞はいつだって子どもが一番で、自分のことは二の次の人でした。<br />あなたが無償の愛を注いでくれたから、ボクはちゃんと人を愛せる大人になれたと思います。",
    n: "いつ帰宅するかもわからないボクに、＜ID-3＞はちゃんとご飯を用意してくれました。<br />わが家がいつも温かかったから、ボクは孤独を感じることがありませんでした。",
    o: "人生の岐路に立ち、どちらに進むべきか悩んだこともありました。<br />でも、どんな道を選んだとしても必ず背中を押してくれる＜ID-3＞がいたから、ボクは前を向くことができました。",
    p: "あのとき、自分のことみたいに喜んでくれてありがとう。<br />＜ID-3＞のうれし涙を見たとき、これまで頑張ってきてよかったと心から思いました。",
    q: "昔から＜ID-3＞は、決して家族の前で弱いところを見せませんでした。<br />「＜ID-3＞がいるから大丈夫」その背中にはいつだって、頼もしい大黒柱の安心感がありました。",

    // 父へのメッセージ（社会人 編）
    r: "実家を出てから気づいたこと。それは＜ID-3＞の偉大さです。<br />大きなことから小さなことまで、どれだけ頼ってきたのかを身にしみて感じました。",
    s: "＜ID-3＞はボクの一番の理解者です。<br />困ったとき、いつもそっと手を差し伸べてくれる＜ID-3＞に、どれだけ救われてきたかわかりません。",
    // ＜ID-4＞で「ある」を選択した場合のみ表示
    t: "実家に帰ることも、だんだん少なくなってしまっています。<br />だからたまに帰省したときの＜ID-3＞らしいおもてなしが、なんだかとっても心地良いんです。",
    //＜ID-4＞で「ある」を選択した場合のみ表示
    u: "覚えていないかもしれないけど、昔＜ID-3＞からもらった大切な言葉があります。<br />「＜ID-4＞」きっと＜ID-3＞が思っているよりずっと、この言葉はボクの人生を変えてくれました。",
    v: "親子だから、どうしたって＜ID-3＞とボクは似ています。<br />そこは似なくていいかなと思うこともあるけれど、＜ID-3＞からもらったギフトをたくさんの人が素敵だと言ってくれます。",
    w: "歳を重ねて、＜ID-3＞との会話は少しずつ変わってきたように思います。<br />これまで聞けなかった本音を＜ID-3＞が話してくれると、大人として認められた気がしてなんだかうれしいんです。",
    x: "＜ID-3＞は子どもたちを比べず、それぞれの個性を大切にしてくれました。<br />そのおかげでボクたちは、自分たちらしくのびのびと成長できたのだと思います。",
    y: "子どもに親の期待を押しつけるようなことを、＜ID-3＞は絶対にしませんでした。<br />自分のことは自分で決めるもの。そうやって育ててくれたから、ボクはいつだって自由でした。",
    z: "これまでの人生を振り返ると、人との出会いにとても恵まれていたと思います。<br />住んだ場所や通った学校、＜ID-3＞がその出会いを作ってくれたんだよね。本当にありがとう。",
    // ＜ID-11＞で、子どもが1人以上いると選択した場合のみ表示
    aa: "子どもを育てるようになって、はじめて子育ての大変さを知りました。<br />＜ID-3＞みたいに上手くはやれないけど、あなたがそうしてくれたように、ボクも全力でわが子を愛したいと思います。",
    // ＜ID-11＞で選択された子ども数に応じて、表示するイラストを切り替え（P.41参照）
    // ＜ID-11＞で、子どもが1人以上いると選択した場合のみ表示
    ab: "＜ID-12＞のことを、いつもかわいがってくれてありがとう。<br />＜ID-12＞と遊ぶ＜ID-3＞の姿を見ていると、昔の記憶がよみがえって胸がジーンと熱くなるんです。",
    ac: "いくつになっても人生を謳歌している＜ID-3＞。<br />そんな＜ID-3＞の元気な姿から、いつもボクは元気をもらっています。",
    ad: "＜ID-3＞に大切に育ててもらったから、ボクにも大切な人ができました。<br />いつもボクの大切な人のことまで、気にかけてくれてありがとう。",

    // 母へのメッセージ（幼少時代 編）
    ae: "昔は自分の名前が好きになれなくて、他の名前に憧れたこともありました。<br />でもこの名に込められた＜ID-5＞の想いを知ってから、自分の名前がとても誇らしくなりました。",
    af: "子どもの頃、イベントのたびに名カメラマンに変身してくれた＜ID-5＞。<br />今でもときどき昔のアルバムを開きたくなるのは、そこに＜ID-5＞の温かい眼差しが残っているからです。",
    ag: "はじめての挑戦は失敗してばかり。＜ID-5＞はいつも、できるようになるまで辛抱強く見守ってくれました。<br />「努力はきっと実る」そう思えるようになったのは、間違いなく＜ID-5＞と過ごしたあの日々のおかげです。",
    ah: "小さい頃、どんなに不安なことでも不思議と最後には乗り越えることができました。<br />＜ID-5＞がそばにいてくれること。それはボクにとって無敵のお守りでした。",
    ai: "＜ID-5＞は、太陽みたいにいつも笑っていてくれました。<br />その笑顔に照らされて、わが家はいつもにぎやかで温かい場所でした。",
    aj: "どちらかというと、＜ID-5＞はしつけに厳しい人でした。<br />でも今はそれが＜ID-5＞なりの優しさだったことが、痛いほどによくわかります。",
    ak: "休日というのは、大人になったボクにとってとにかくのんびりしたい時間です。<br />きっと＜ID-5＞もそうだったはずなのに、休みの日にたくさん思い出を作ってくれてありがとう。",
    al: "人一倍家族愛の強い＜ID-5＞のことだから、単身赴任で家族と離れるのはきっとつらかったと思います。<br />家族のためなら自分の犠牲もいとわない。そんな＜ID-5＞は、誰が何と言おうとカッコいいです。",

    // 母へのメッセージ（学生時代 編）
    am: "誰よりも早く起きて、当たり前のように毎日弁当を持たせてくれた＜ID-5＞。<br />どれだけ大変だったか想像もできません。献身的にサポートしてくれて本当にありがとう。",
    an: "思い返してみると、ボクはとても充実した学生生活を送れたと思います。<br />それはボク以上に大変な思いをしながら、伴走しつづけてくれた＜ID-5＞のおかげです。",
    ao: "＜ID-5＞は昔から、ボクが本気でやりたいことには支援を惜しまない人でした。<br />これまで経験させてもらったことすべてが、ボクにとってかけがえのない宝物です。",
    ap: "いつだったか＜ID-5＞が、ボクを守るために本気で怒ってくれたことがありました。<br />いつもは穏やかな人だから、守ってくれて本当にうれしかったのを今でも覚えています。",
    aq: "＜ID-5＞はいつだって子どもが一番で、自分のことは二の次の人でした。<br />あなたが無償の愛を注いでくれたから、ボクはちゃんと人を愛せる大人になれたと思います。",
    ar: "いつ帰宅するかもわからないボクに、＜ID-5＞はちゃんとご飯を用意してくれました。<br />わが家がいつも温かかったから、ボクは孤独を感じることがありませんでした。",
    as: "人生の岐路に立ち、どちらに進むべきか悩んだこともありました。<br />でも、どんな道を選んだとしても必ず背中を押してくれる＜ID-5＞がいたから、ボクは前を向くことができました。",
    at: "あのとき、自分のことみたいに喜んでくれてありがとう。<br />＜ID-5＞のうれし涙を見たとき、これまで頑張ってきてよかったと心から思いました。",
    au: "昔から＜ID-5＞は、決して家族の前で弱いところを見せませんでした。<br />「＜ID-5＞がいるから大丈夫」その背中にはいつだって、頼もしい大黒柱の安心感がありました。",

    // 母へのメッセージ（社会人 編）
    av: "実家を出てから気づいたこと。それは＜ID-5＞の偉大さです。<br />大きなことから小さなことまで、どれだけ頼ってきたのかを身にしみて感じました。",
    aw: "＜ID-5＞はボクの一番の理解者です。<br />困ったとき、いつもそっと手を差し伸べてくれる＜ID-5＞に、どれだけ救われてきたかわかりません。",
    ax: "実家に帰ることも、だんだん少なくなってしまっています。<br />だからたまに帰省したときの＜ID-5＞らしいおもてなしが、なんだかとっても心地良いんです。",
    // ＜ID-4＞で「ある」を選択した場合のみ表示
    ay: "覚えていないかもしれないけど、昔＜ID-5＞からもらった大切な言葉があります。<br />「＜ID-6＞」きっと＜ID-5＞が思っているよりずっと、この言葉はボクの人生を変えてくれました。",
    az: "親子だから、どうしたって＜ID-5＞とボクは似ています。<br />そこは似なくていいかなと思うこともあるけれど、＜ID-5＞からもらったギフトをたくさんの人が素敵だと言ってくれます。",
    ba: "歳を重ねて、＜ID-5＞との会話は少しずつ変わってきたように思います。<br />これまで聞けなかった本音を＜ID-5＞が話してくれると、大人として認められた気がしてなんだかうれしいんです。",
    // ＜ID-9＞＜ID-10＞で選択された兄弟姉妹条件に応じて、表示するイラストを切り替え（P.40参照）
    // ＜ID-9＞で、兄弟姉妹が1人以上いると選択した場合のみ表示
    bb: "＜ID-5＞は子どもたちを比べず、それぞれの個性を大切にしてくれました。<br />そのおかげでボクたちは、自分たちらしくのびのびと成長できたのだと思います。",
    bc: "子どもに親の期待を押しつけるようなことを、＜ID-5＞は絶対にしませんでした。<br />自分のことは自分で決めるもの。そうやって育ててくれたから、ボクはいつだって自由でした。",
    bd: "これまでの人生を振り返ると、人との出会いにとても恵まれていたと思います。<br />住んだ場所や通った学校、＜ID-5＞がその出会いを作ってくれたんだよね。本当にありがとう。",
    // ＜ID-11＞で、子どもが1人以上いると選択した場合のみ表示
    be: "子どもを育てるようになって、はじめて子育ての大変さを知りました。<br />＜ID-5＞みたいに上手くはやれないけど、あなたがそうしてくれたように、ボクも全力でわが子を愛したいと思います。",
    // ＜ID-11＞で選択された子ども数に応じて、表示するイラストを切り替え（P.41参照）
    // ＜ID-11＞で、子どもが1人以上いると選択した場合のみ表示
    bf: "＜ID-12＞のことを、いつもかわいがってくれてありがとう。<br />＜ID-12＞と遊ぶ＜ID-5＞の姿を見ていると、昔の記憶がよみがえって胸がジーンと熱くなるんです。",
    bg: "いくつになっても人生を謳歌している＜ID-5＞。<br />そんな＜ID-5＞の元気な姿から、いつもボクは元気をもらっています。",
    bh: "＜ID-5＞に大切に育ててもらったから、ボクにも大切な人ができました。<br />いつもボクの大切な人のことまで、気にかけてくれてありがとう。",
  }
};



// WEBPACK FOOTER //
// ./src/data/storiesChildToParent.js